import { SlIcon } from "@shoelace-style/shoelace/dist/react";
import React, { useState, useEffect } from "react";
import LikeSvg from "../assets/images/like.svg";
import DislikeSvg from "../assets/images/dislike.svg";
import CommentSvg from "../assets/images/comment.svg";
import ForwardSvg from "../assets/images/forward.svg";
import MenuSvg from "../assets/images/menu.svg";
import config from "../config";
import detectLanguage from "./promotedPreviewStyles";
import CreativeNameDisplay from "../shared/CreativeNameDisplay";
function VideoExpandable({ preview }) {
  const [showImage, setShowImage] = useState(false);
  const [timeoutSet, setTimeoutSet] = useState(false);
  useEffect(() => {
    const video = document.getElementById("myVideo");
    const handleTimeUpdate = () => {
      // start time was stored in impressions, similarly end time was stored in clicks
      const end = ((preview.end_time || preview.clicks) - (preview.start_time || preview.impressions)) * 1000;
      if ((video.currentTime >= (preview.start_time || preview.impressions)) && !timeoutSet) {
        setShowImage(true);
        setTimeout(() => {
          setShowImage(false);
          setTimeoutSet(true);
        }, end); // Hide image after 5 seconds
      }
    };

    video.addEventListener("timeupdate", handleTimeUpdate);

    return () => {
      video.removeEventListener("timeupdate", handleTimeUpdate);
    };
  }, [preview, timeoutSet]);
  const { heading, descrip } = detectLanguage(preview.head_line || config.HEADLINE)

  return (
    <>

      <div className="download-preview">
        <CreativeNameDisplay preview={preview} />

        <div className="preview-inner">
          <div className="h-full">
            <div className="min-h-[40%] max-h-[40%] rounded-t-[24px] bg-black d-flex items-center">
              <video
                id="myVideo"
                src={preview?.post_video || "https://video.twimg.com/ext_tw_video/1750496838581723136/pu/vid/avc1/1280x720/nVwBnsdb0XrI58a6.mp4"}
                type="video/mp4"
                controls
              ></video>
            </div>
            <div className="flex flex-col justify-between min-h-[60%] contentArea">
              <div className={`${showImage ? "anim-top" : "hide-post"} ${timeoutSet ? "reverse-anim" : ""}`}>
                {preview?.gallery?.length > 1 && <img className={`rounded-b-[24px]`} src={preview?.gallery[1]?.image} alt="ad"></img>}
              </div>
              <div>
                {preview?.gallery && (
                  <img src={preview?.gallery[0]?.image} alt="ad" />
                )}
              </div>
              <div className="px-2 mt-2">
                <h5 style={heading}>{preview.head_line || config.HEADLINE}</h5>
                <p style={descrip} className="text-base">
                  {preview.description || config.DESCRIPTION}
                </p>
              </div>
              <div>
                <div className="px-2 text-xs mb-3">
                  <div className="d-flex gap-1 items-center">
                    <SlIcon className="text-gray-400" name="clock-4" library="lucide" />
                    <span className="text-bold">7m ago</span>
                    <span className="text-gray-400">/ 2 of 196 Stories</span>
                  </div>
                  <div className="border-gray-200 my-2 px-0 py-0 border-b"></div>
                  <div className="d-flex justify-between items-center my-0 px-2 py-0">
                    <div className="d-flex gap-2 items-center my-1">
                      <div className="d-flex items-center gap-[2px]">
                        <img src={LikeSvg} alt="like"></img>
                        <span className="text-gray-400">720</span>
                      </div>
                      <div className="d-flex items-center gap-[2px]">
                        <img src={DislikeSvg} alt="dislike"></img>
                        <span className="text-gray-400">18</span>
                      </div>
                      <div className="d-flex items-center gap-[2px]">
                        <img src={CommentSvg} alt="comment"></img>
                        <span className="text-gray-400">4</span>
                      </div>
                    </div>
                    <div className="d-flex gap-2 items-center my-1">
                      <img src={MenuSvg} alt="menu"></img>
                      <img src={ForwardSvg} alt="forward"></img>
                    </div>
                  </div>
                </div>
              </div>
              {
                showImage && <SlIcon name="x" library="lucide" onClick={() => { setShowImage(false); setTimeoutSet(true) }} className="absolute top-0 right-1 text-red-600 hover:cursor-pointer"></SlIcon>
              }
            </div>



          </div>
        </div>
      </div>
    </>
  );
}

export default VideoExpandable;
